import React from 'react'
import styled from 'styled-components'
import { media } from 'styles/media'

import ButtonLink from 'components/display/ButtonLink'
import { FixedColumnsMasonry } from 'components/landing/MasonryImages'
import {
  SectionTitle,
  HeadingXxl,
  ParagraphSm,
} from 'components/display/Typography'
import { masonryImages } from '../content'

const Banner = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-neutral-200']?.value};
`

const BannerInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px 0 16px;

  ${media.xl`
    display: flex;
    flex-direction: row;
    padding: 40px 16px;

    & > * {
      width: 50%;
    }
  `}
`

const Content = styled.div`
  padding: 34px 0;

  ${media.xl`
    padding: 100px 34px;
  `}

  ${HeadingXxl} {
    margin-bottom: 32px;
  }
`

const Storytelling = () => {
  return (
    <Banner>
      <BannerInner>
        <FixedColumnsMasonry
          images={masonryImages}
          columnsCount={2}
          imagesPerColumn={{
            1: 2,
            2: 2,
            3: 2,
          }}
          gutter={26}
        />
        <Content>
          <SectionTitle>Storytelling</SectionTitle>
          <HeadingXxl>
            Join our Storyteller community and share your adventures
          </HeadingXxl>
          <ParagraphSm style={{ marginBottom: '32px' }}>
            Through inspiring photos, words and videos, our Storytellers bring
            our unique stays and local adventures to life. Grab your camera,
            rally your crew and join us on our mission to deliver
            soul-fulfilling escapes.
          </ParagraphSm>
          <ButtonLink
            href="/stories-storytellers"
            inline
            compact
            ghost
            uppercase={false}
          >
            Become a Storyteller
          </ButtonLink>
        </Content>
      </BannerInner>
    </Banner>
  )
}

export default Storytelling
